import {FilterOperator} from "@6grain/masofa-monolith-api-client/common/model/filterOperator";
import {User, ProfileInfoViewModel} from '@6grain/masofa-monolith-api-client/identity';

export interface Filter
{
  filterField?: string | null;
  filterValue?: any | null;
  filterOperator?: number | any ;
}
export function getDeepField(model: any, modelField: string, defValue: unknown = ''): any {
  if (modelField) {
    const fields = modelField.split('.');
    for (let index = 0; index < fields.length; index++) {
      const field = fields[index];
      if (!model[field] && model[field] !== false) {
        if (index === fields.length - 1) {
          model[field] = defValue;
        } else {
          model[field] = {};
        }
      }
      model = model[field];
    }
  } else {
    return defValue
  }
  return model;
}


export function buildFilterQuery(filters: Record<string, Object>, operator: FilterOperator = FilterOperator.NUMBER_0): Filter[] {
  const fieldFilters: any[] = [];
  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        fieldFilters.push({
          filterField: key,
          filterOperator: operator, // Equals operator
          filterValue: value
        });
      }
    });
  }
  return fieldFilters;
}


export function replaceFilter(prop:string, value:Filter , filters:Filter[]  ): Filter[] {
  const existingIndex = filters.findIndex(f => f.filterField === prop);
  if (existingIndex !== -1) {
    filters[existingIndex] = value;
  }else {
    filters.push(value);
  }
  return filters;
}

export function reverseFilterQuery(fieldFilters: any[]): Record<string, any> {
  const filters: Record<string, any> = {};

  if (fieldFilters && Array.isArray(fieldFilters)) {
    fieldFilters.forEach(filter => {
      if (filter.filterField && filter.filterValue !== null && filter.filterValue !== undefined) {
        filters[filter.filterField] = filter.filterValue;
      }
    });
  }

  return filters;
}

export function userNames(user: User | ProfileInfoViewModel | null | undefined) {
  if (!user) {
    return '';
  }
  if (user.firstName && user.lastName) {
    return `${user.firstName}  ${user.lastName}`
  } else if (user.userName) {
    return `${user.userName}`
  }
  return ''
}

export function handleErrors(errorResponse: any): string {
  const errorMsg = typeof errorResponse.error === 'string' ? errorResponse.error : null;

  const errorMessages: string[] = [];
  errorResponse = errorResponse.error.errors;
  if (errorResponse && typeof errorResponse === 'object') {
    Object.keys(errorResponse).forEach(key => {
      const messages = errorResponse[key];
      if (Array.isArray(messages)) {
        errorMessages.push(...messages);
      }
    });
  }

  return errorMsg || errorMessages.join(', ') || ['An unknown error occurred'];
}


export function mergeParams(params1: any, params2: any) {
  if (params1 && params2) {
    Object.keys(params2).forEach(key => {
      if (params2[key] !== null && params2[key] !== undefined) {
        params1[key] = params2[key];
      }
    });
  }
}


export  function  getBorderColorFromPolygonColor(polygonColor: string): string {
  try {
    let r: number, g: number, b: number;

    if (polygonColor.startsWith('#')) {
      const hex = polygonColor.slice(1);
      if (hex.length === 3) {
        r = parseInt(hex[0].repeat(2), 16);
        g = parseInt(hex[1].repeat(2), 16);
        b = parseInt(hex[2].repeat(2), 16);
      } else if (hex.length === 6) {
        r = parseInt(hex.slice(0, 2), 16);
        g = parseInt(hex.slice(2, 4), 16);
        b = parseInt(hex.slice(4, 6), 16);
      } else {
        return 'rgba(0, 0, 0, 0.85)';
      }
    }
    else {
      const match = polygonColor.match(/(\d+),\s*(\d+),\s*(\d+)/);
      if (!match) return 'rgba(0, 0, 0, 0.85)';

      r = parseInt(match[1]);
      g = parseInt(match[2]);
      b = parseInt(match[3]);
    }

    const darken = (value: number) => Math.max(0, Math.min(255, Math.round(value * 0.8)));

    return `rgba(${darken(r)}, ${darken(g)}, ${darken(b)}, 0.85)`;

  } catch {
    return 'rgba(0, 0, 0, 0.85)';
  }
}

export async function saveBlob(blob: Blob, filename: string): Promise<void> {
  const nav: any = (window as any).navigator;
  if (nav && typeof nav.msSaveOrOpenBlob === 'function') {
    nav.msSaveOrOpenBlob(blob, filename);
    return;
  }

  const url = window.URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = url;
  a.download = filename;

  document.body.appendChild(a);

  try {
    await new Promise<void>((resolve) => {
      requestAnimationFrame(() => {
        setTimeout(() => {
          a.click();
          resolve();
        }, 0);
      });
    });

    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) {
      try {
        window.open(url, '_blank', 'noopener');
      } catch {
        /* ignore */
      }
    }
  } catch {
    try {
      window.open(url, '_blank', 'noopener');
    } catch {
      /* ignore */
    }
  } finally {
    if (a.parentNode) document.body.removeChild(a);
    setTimeout(() => {
      try { window.URL.revokeObjectURL(url); } catch { /* ignore */ }
    }, 500);
  }


}

export interface FullscreenImageMeta {
  info?: string;
}

export function openImageFullscreen(
  imageUrl: string,
  imageUrls?: string[],
  startIndex = 0,
  imageMeta?: FullscreenImageMeta[]
): void {
  if (!imageUrl) return;

  const sources = (imageUrls && imageUrls.length ? imageUrls : [imageUrl]).filter(Boolean);
  if (!sources.length) return;
  let currentIndex = Math.min(Math.max(startIndex, 0), sources.length - 1);

  const container = document.createElement('div');
  container.className = 'msf-fullscreen-overlay';
  Object.assign(container.style, {
    position: 'fixed',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgba(0,0,0,0.95)',
    zIndex: '9999',
    cursor: 'default'
  });

  const img = document.createElement('img');
  Object.assign(img.style, {
    maxWidth: '90%',
    maxHeight: '90%',
    objectFit: 'contain',
    userSelect: 'none',
    pointerEvents: 'none'
  });

  const closeBtn = document.createElement('button');
  closeBtn.type = 'button';
  closeBtn.textContent = '✕';
  Object.assign(closeBtn.style, {
    position: 'absolute',
    top: '16px',
    right: '16px',
    width: '40px',
    height: '40px',
    border: 'none',
    borderRadius: '9999px',
    background: 'rgba(255, 255, 255, 0.2)',
    color: '#fff',
    fontSize: '20px',
    cursor: 'pointer'
  });

  const indexLabel = document.createElement('div');
  Object.assign(indexLabel.style, {
    position: 'absolute',
    top: '22px',
    left: '50%',
    transform: 'translateX(-50%)',
    color: '#fff',
    fontSize: '14px',
    background: 'rgba(0, 0, 0, 0.4)',
    padding: '4px 10px',
    borderRadius: '9999px'
  });

  const infoBanner = document.createElement('div');
  Object.assign(infoBanner.style, {
    position: 'absolute',
    left: '50%',
    bottom: '20px',
    transform: 'translateX(-50%)',
    color: '#fff',
    fontSize: '14px',
    background: 'rgba(0, 0, 0, 0.55)',
    padding: '8px 14px',
    borderRadius: '10px',
    maxWidth: '80vw',
    textAlign: 'left',
    whiteSpace: 'pre-wrap',
    overflow: 'auto',
    maxHeight: '28vh'
  });

  const createNavButton = (direction: 'prev' | 'next'): HTMLButtonElement => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.textContent = direction === 'prev' ? '‹' : '›';
    Object.assign(btn.style, {
      position: 'absolute',
      top: '50%',
      [direction === 'prev' ? 'left' : 'right']: '16px',
      transform: 'translateY(-50%)',
      width: '44px',
      height: '44px',
      border: 'none',
      borderRadius: '9999px',
      background: 'rgba(255, 255, 255, 0.2)',
      color: '#fff',
      fontSize: '30px',
      lineHeight: '1',
      cursor: 'pointer',
      display: sources.length > 1 ? 'block' : 'none'
    });
    return btn;
  };

  const prevBtn = createNavButton('prev');
  const nextBtn = createNavButton('next');

  const renderImage = () => {
    img.src = sources[currentIndex];
    indexLabel.textContent = `${currentIndex + 1} / ${sources.length}`;
    const infoText = imageMeta?.[currentIndex]?.info?.trim() || '';
    infoBanner.textContent = infoText;
    infoBanner.style.display = infoText ? 'block' : 'none';
  };

  const goTo = (index: number) => {
    currentIndex = (index + sources.length) % sources.length;
    renderImage();
  };

  const stopEvent = (ev: Event) => {
    ev.stopPropagation();
  };

  renderImage();
  container.appendChild(img);
  container.appendChild(indexLabel);
  container.appendChild(closeBtn);
  container.appendChild(prevBtn);
  container.appendChild(nextBtn);
  container.appendChild(infoBanner);
  document.body.appendChild(container);

  const cleanUp = () => {
    document.removeEventListener('fullscreenchange', onFsChange);
    document.removeEventListener('keydown', onKey);
    container.removeEventListener('click', onClose);
    if (container.parentNode) {
      container.parentNode.removeChild(container);
    }
  };

  const onClose = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen().catch(() => {});
    } else {
      cleanUp();
    }
  };

  const onFsChange = () => {
    if (!document.fullscreenElement) {
      cleanUp();
    }
  };

  const onKey = (ev: KeyboardEvent) => {
    if (ev.key === 'Escape') {
      onClose();
    } else if (ev.key === 'ArrowLeft' && sources.length > 1) {
      goTo(currentIndex - 1);
    } else if (ev.key === 'ArrowRight' && sources.length > 1) {
      goTo(currentIndex + 1);
    }
  };

  container.addEventListener('click', onClose);
  closeBtn.addEventListener('click', onClose);
  prevBtn.addEventListener('click', (ev) => {
    stopEvent(ev);
    goTo(currentIndex - 1);
  });
  nextBtn.addEventListener('click', (ev) => {
    stopEvent(ev);
    goTo(currentIndex + 1);
  });
  img.addEventListener('click', stopEvent);
  indexLabel.addEventListener('click', stopEvent);
  infoBanner.addEventListener('click', stopEvent);
  closeBtn.addEventListener('click', stopEvent);
  prevBtn.addEventListener('click', stopEvent);
  nextBtn.addEventListener('click', stopEvent);
  document.addEventListener('fullscreenchange', onFsChange);
  document.addEventListener('keydown', onKey);

  const req = (container as any).requestFullscreen || (container as any).webkitRequestFullscreen || (container as any).msRequestFullscreen;
  if (req) {
    req.call(container).catch(() => {
      console.log('Fullscreen not available, showing overlay only');
    });
  }
}
